import React from "react";
import { useLocation, Route, Switch, Redirect } from "react-router-dom";
// reactstrap components
import { Container } from "reactstrap";
// core components
import AdminNavbar from "../components/Navbars/AdminNavbar";
// import AdminFooter from "components/Footers/AdminFooter.js";
import AdminFooter from "../components/Footers/AdminFooter";
import Sidebar from "../components/Sidebar/Sidebar";

import { Routes } from "../routes";

export default function EducationOfficer(props) {
  const mainContent = React.useRef(null);
  const location = useLocation();
  // var document: Document;
  React.useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    mainContent.current.scrollTop = 0;
  }, [location]);

  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.layout === "/blockOfficer") {
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  };

  const getBrandText = (path) => {
    for (let i = 0; i < Routes.blockOfficerRoutes.length; i++) {
      let localPath = props.location.pathname.split("/");
      if (!isNaN(localPath[localPath.length - 1])) {
        localPath.pop();
        let s = localPath.join("/") + "/:id";
        // console.log(s);
        // props.location.pathname = s;
        if (
          s.indexOf(
            Routes.teacherRoutes[i].layout + Routes.teacherRoutes[i].path
          ) !== -1
        ) {
          return Routes.teacherRoutes[i].name;
        }
      }
      if (
        props.location.pathname.indexOf(
          Routes.blockOfficerRoutes[i].layout +
            Routes.blockOfficerRoutes[i].path
        ) !== -1
      ) {
        return Routes.blockOfficerRoutes[i].name;
      }
    }
    return "Brand";
  };

  return (
    <React.Fragment>
      <Sidebar
        {...props}
        routes={Routes.blockOfficerRoutes}
        logo={{
          innerLink: "/admin/index",
          imgSrc: require("../assets/img/brand/argon-react.png").default,
          imgAlt: "...",
        }}
      />
      <div className="main-content" ref={mainContent}>
        <AdminNavbar
          {...props}
          brandText={getBrandText(props.location.pathname)}
        />
        <Switch>
          {getRoutes(Routes.blockOfficerRoutes)}
          <Redirect from="*" to="/blockOfficer/block" />
        </Switch>
        <Container fluid>
          <AdminFooter />
        </Container>
      </div>
    </React.Fragment>
  );
}
